/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type StockByOfferIdQueryVariables = Types.Exact<{
  offerId: Types.Scalars['String']['input'];
}>;

export type StockByOfferIdQuery = {
  __typename?: 'Query';
  getAvailableStockByOfferId?: number;
};

export const StockByOfferIdDocument = /*#__PURE__*/ `
    query StockByOfferId($offerId: String!) {
  getAvailableStockByOfferId(offerId: $offerId)
}
    `;

export function useStockByOfferIdQuery(
  options: Omit<Urql.UseQueryArgs<StockByOfferIdQueryVariables>, 'query'>,
) {
  return Urql.useQuery<StockByOfferIdQuery, StockByOfferIdQueryVariables>({
    query: StockByOfferIdDocument,
    ...options,
  });
}
